import React, { useState } from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation } from '@tracking';

import ScoopedArticle from './ScoopedArticle';
import ScoopsRightRail from './ScoopsRightRail';
import { ScoopsPageContentProps } from './interfaces';

const INITIAL_DISPLAY_COUNT = 10;

const ScoopsPageContent = ({
  articles,
  mostPopularArticles,
  upcomingEvents,
  communityComments,
  briefingNewsletter,
}: ScoopsPageContentProps) => {
  const [displayCount, setDisplayCount] = useState(INITIAL_DISPLAY_COUNT);

  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.ScoopsPageContent,
  });

  const handleLoadMore = () => {
    setDisplayCount((prevCount) => prevCount + INITIAL_DISPLAY_COUNT);
    trackEvent({ clickTarget: ClickTarget.ScoopsReadMore });
  };

  const visibleArticles = articles.slice(0, displayCount);
  const hasMoreArticles = displayCount < articles.length;

  if (!articles || articles.length === 0) {
    return (
      <p className="alert alert-info">No scoops found at this time. Please check back later.</p>
    );
  }

  return (
    <Track>
      <main className="relative px-16 sm:px-28">
        <div className="m-auto max-w-container-lg">
          <div className="flex flex-col md:flex-row">
            <div className="w-full md:max-w-[740px] md:pr-28 lg:max-w-[940px] lg:pr-56">
              <h1 className="mb-0 mt-0 text-balance text-center text-headline-alt-md sm:text-left md:text-headline-alt-lg">
                First Reported by The Information
              </h1>
              <p className="mt-0 text-center font-suisse-neue text-byline-lg sm:text-left">
                Our reporting drives conversations across the industry
              </p>

              <div className="mt-40 w-full md:mt-56 md:max-w-[740px] md:pr-28 lg:max-w-[940px] lg:pr-56">
                {visibleArticles.map((article, index) => (
                  <ScoopedArticle
                    article={article}
                    index={index}
                    key={article.id}
                    visibleArticles={visibleArticles}
                    hasMoreArticles={hasMoreArticles}
                    onLoadMore={handleLoadMore}
                  />
                ))}
              </div>
            </div>
            <ScoopsRightRail
              communityComments={communityComments}
              upcomingEvents={upcomingEvents}
              mostPopularArticles={mostPopularArticles}
              briefingNewsletter={briefingNewsletter}
            />
          </div>
        </div>
      </main>
    </Track>
  );
};

export default ScoopsPageContent;
